/* IHC rails: previous/next arrows for horizontal product/brand/review rows. One small shared script. */
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-ihx-rail]:not([data-ihx-on])').forEach(function (wrap) {
      var rail = wrap.querySelector('.ihx-rail'), prev = wrap.querySelector('[data-ihx-prev]'), next = wrap.querySelector('[data-ihx-next]');
      if (!rail || !prev || !next) return;
      wrap.setAttribute('data-ihx-on', '');
      function step() { return Math.max(rail.clientWidth * 0.9, 200); }
      function sync() {
        prev.disabled = rail.scrollLeft < 8;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
      }
      prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
